import { useTranslations } from 'next-intl'

import classNames from 'classnames'

import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Link from '~/components/atoms/Link/Link'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import usePremiumContent, { PremiumBannerType } from '~/hooks/usePremiumContent'

import styles from './SignUpForPremiumBanner.module.css'

export default function SignUpForPremiumBanner() {
  const t = useTranslations('signUpForPremiumBanner')
  const { handleClick, linkText, showPremiumPrompt } = usePremiumContent()

  if (!showPremiumPrompt) return null

  return (
    <div className={classNames(styles.base, 'prose')}>
      <Container gutters={gutterTypes.always}>
        <Text size={TextSizes.bodySml}>
          <Link
            href="/signup"
            onClick={e => {
              handleClick(e, PremiumBannerType.articleHeader)
            }}
          >
            <strong>{linkText}</strong>
          </Link>{' '}
          {t('accessContent')}
        </Text>
      </Container>
    </div>
  )
}
